import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { FiEdit, FiCheck, FiX, FiTrash } from "react-icons/fi";
import { QuestionSetCategory } from '../../Platform/Common/types';

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_code: string;   // Role ID
  exp?: number;      // Expiration timestamp (optional)
}

const B2CQsetCategoryManager = () => {
  const [questionSetCategories, setQuestionSetCategories] = useState<QuestionSetCategory[]>([]);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");


  const [isAddingNew, setIsAddingNew] = useState(false);
  const [editRow, setEditRow] = useState<number | null>(null); // Track the row currently being edited
  const [newQuestionSetCategory, setNewQuestionSetCategory] = useState<QuestionSetCategory | null>(null);


  // Fetch enrolled students when tenant ID is set
const fetchQuestionSetCategories = useCallback(async () => {
  try {
    const b2c_apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
    const response = await axios.get(`${b2c_apiurl}/qset-categories`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('b2c_token')}`,
      },
    });
    setQuestionSetCategories(response.data);
  } catch (error) {
    console.error("Failed to load question set categories", error);
  }
}, []);

useEffect(() => {
  fetchQuestionSetCategories();
}, [fetchQuestionSetCategories]);

  const handleDeleteQuestionSetCategory = async (category_id: number) => {
    // Placeholder function
       try {
         const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
       console.log("Printing Token from Delete" + localStorage.getItem("b2c_token"));
       await axios.delete(apiurl + `/qset-category/${category_id}`, {
         headers: {
           Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
         }
       });
       fetchQuestionSetCategories();
       setEditRow(null); // Reset edit mode after successful update
       toast({ title: "Question Set Category deleted successfully", status: "success" });
     } catch (error) {
       console.error("Failed to delete Question Set Category", error);
       toast({ title: "Failed to delete Question Set Category", status: "error" });
     }
   
  };

  const handleAddNewQuestionSetCategory = () => {
    setIsAddingNew(true);
    setNewQuestionSetCategory({ tenant_id:0, category_id: 0, category_name: '', subject: '',  target_exam:'' , grade_level:'', created_at: new Date(), updated_at: new Date()});
  };

  const handleRemoveNewQuestionSetCategory = () => {
    setIsAddingNew(false);
    setNewQuestionSetCategory(null);
  };

  const handleSaveQuestionSetCategory = async (questionsetcategory: QuestionSetCategory) => {
    try {

        const payload = {
            category_name: questionsetcategory.category_name,
            subject: questionsetcategory.subject,
            grade_level: questionsetcategory.grade_level,
            created_at: questionsetcategory.created_at,
            updated_at: questionsetcategory.updated_at,
            tenant_id: questionsetcategory.tenant_id,
            target_exam: questionsetcategory.target_exam,
        };
      const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
      
      console.log("printing questionsetcategory user payload",payload);

      const response = await axios.post(apiurl+`/create-qset-category/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
        }
      });
      setQuestionSetCategories([...questionSetCategories, response.data]);
      setIsAddingNew(false);
      setNewQuestionSetCategory(null);
      toast({ title: "QuestionSetCategory added successfully", status: "success" });
    } catch (error) {
      console.error("Failed to save QuestionSetCategory ", error);
      toast({ title: "Failed to add QuestionSetCategory ", status: "error" });
    }
  };

  const handleUpdateQuestionSetCategory = async (questionsetcategory: QuestionSetCategory) => {
    try {
        

        const payload = {
            category_name: questionsetcategory.category_name,
            subject: questionsetcategory.subject,
            grade_level: questionsetcategory.grade_level,
            created_at: questionsetcategory.created_at,
            updated_at: questionsetcategory.updated_at,
            tenant_id: questionsetcategory.tenant_id,
            target_exam: questionsetcategory.target_exam,
        };
      const apiurl = process.env.REACT_APP_B2C_API_URL || 'https://default-url.com';
     
      console.log("Printing Token from Update" + localStorage.getItem("b2c_token"));
      await axios.put(apiurl+`/update-qset-category/${questionsetcategory.category_id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('b2c_token')}`
        }
      });
      fetchQuestionSetCategories();
      setEditRow(null); // Reset edit mode after successful update
      toast({ title: "QuestionSetCategory updated successfully", status: "success" });
    } catch (error) {
      console.error("Failed to update QuestionSetCategory", error);
      toast({ title: "Failed to update QuestionSetCategory", status: "error" });
    }
  };

  const handleEditRow = (user_id: number) => {
    setEditRow(user_id);
    setIsAddingNew(false); // Disable add tenant while editing
  };

  const handleCancelEdit = () => {
    setEditRow(null);
    setIsAddingNew(false);
  };


  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>Question Set Category Manager</Heading>
      </VStack>
            <Box mt={4}>
               <Text fontWeight="bold">Existing Question Set Categories</Text>
        <Button  mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewQuestionSetCategory} isDisabled={isAddingNew || editRow !== null}>
          + Question Set Category
        </Button>
      </Box>
      <Box mt={4}>
       
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Category Name</Th>
              <Th>Subject</Th>
              <Th>Target Exam</Th>
              <Th>Grade Level</Th>
              {/* <Th>Created At</Th>
              <Th>Updated At</Th> */}
             
            <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">
            {isAddingNew && newQuestionSetCategory && (
                <Tr>
                <Td>New</Td>
                <Td>
                    <Input
                    size="sm"
                    fontSize="sm"
                    value={newQuestionSetCategory.category_name}
                    onChange={(e) =>
                        setNewQuestionSetCategory({ ...newQuestionSetCategory, category_name: e.target.value })
                    }
                    />
                </Td>
                <Td>
                    <Input
                    size="sm"
                    fontSize="sm"
                    value={newQuestionSetCategory.subject}
                    onChange={(e) =>
                        setNewQuestionSetCategory({ ...newQuestionSetCategory, subject: e.target.value })
                    }
                    />
                </Td>
                <Td>
                    <Input
                    size="sm"
                    fontSize="sm"
                    value={newQuestionSetCategory.target_exam}
                    onChange={(e) =>
                        setNewQuestionSetCategory({ ...newQuestionSetCategory, target_exam: e.target.value })
                    }
                    />
                </Td>
                <Td>
                    <Input
                    size="sm"
                    fontSize="sm"
                    value={newQuestionSetCategory.grade_level}
                    onChange={(e) =>
                        setNewQuestionSetCategory({ ...newQuestionSetCategory, grade_level: e.target.value })
                    }
                    />
                </Td>

                <Td>
                <HStack>
                    <Tooltip label="Save">
                    <Button size="sm" onClick={() => handleSaveQuestionSetCategory(newQuestionSetCategory)}>
                        <FiCheck />
                    </Button>
                    </Tooltip>
                    <Tooltip label="Cancel">
                    <Button size="sm" ml={2} onClick={handleRemoveNewQuestionSetCategory}>
                        <FiX />
                    </Button>
                    </Tooltip>
                </HStack>
                </Td>
                </Tr>
            )}
            {questionSetCategories.map((questionSetCategory) => (
                <Tr
                key={questionSetCategory.category_id}
                opacity={editRow && editRow !== questionSetCategory.category_id ? 0.5 : isAddingNew ? 0.5 : 1}
                >
                <Td>{questionSetCategory.category_id}</Td>
                <Td>
                    {editRow === questionSetCategory.category_id ? (
                    <Input
                        size="sm"
                        fontSize="sm"
                        value={questionSetCategory.category_name}
                        onChange={(e) => {
                        questionSetCategory.category_name = e.target.value;
                        setQuestionSetCategories([...questionSetCategories]);
                        }}
                    />
                    ) : (
                        questionSetCategory.category_name
                    )}
                </Td>
                <Td>
                    {editRow === questionSetCategory.category_id ? (
                    <Input
                        size="sm"
                        fontSize="sm"
                        value={questionSetCategory.subject}
                        onChange={(e) => {
                        questionSetCategory.subject = e.target.value;
                        setQuestionSetCategories([...questionSetCategories]);
                        }}
                    />
                    ) : (
                        questionSetCategory.subject
                    )}
                </Td>
                <Td>
                    {editRow === questionSetCategory.category_id ? (
                    <Input
                        size="sm"
                        fontSize="sm"
                        value={questionSetCategory.target_exam}
                        onChange={(e) => {
                        questionSetCategory.target_exam = e.target.value;
                        setQuestionSetCategories([...questionSetCategories]);
                        }}
                    />
                    ) : (
                        questionSetCategory.target_exam
                    )}
                </Td>
                <Td>
                    {editRow === questionSetCategory.category_id ? (
                    <Input
                        size="sm"
                        fontSize="sm"
                        value={questionSetCategory.grade_level}
                        onChange={(e) => {
                        questionSetCategory.grade_level = e.target.value;
                        setQuestionSetCategories([...questionSetCategories]);
                        }}
                    />
                    ) : (
                        questionSetCategory.grade_level
                    )}
                </Td>
                
                <Td>
                    {editRow === questionSetCategory.category_id ? (
                    <HStack>
                        <Tooltip label="Update">
                        <Button size="sm" onClick={() => handleUpdateQuestionSetCategory(questionSetCategory)}>
                            <FiCheck />
                        </Button>
                        </Tooltip>
                        <Tooltip label="Cancel">
                        <Button size="sm" ml={2} onClick={handleCancelEdit}>
                            <FiX />
                        </Button>
                        </Tooltip>
                        </HStack>
                    ) : (
                        <>
                    <Tooltip label="Edit">
                        <Button size="sm" onClick={() => handleEditRow(questionSetCategory.category_id)} mr={8}>
                        <FiEdit />
                        </Button>
                    </Tooltip>
                    <Tooltip label="Delete">
                    <Button
                            size="sm"
                            colorScheme="red"
                            onClick={() => {
                            if (window.confirm("Are you sure you want to delete this lesson?")) {
                                handleDeleteQuestionSetCategory(questionSetCategory.category_id);
                            }
                            }}
                        >
                            <FiTrash />
                        </Button>
                    </Tooltip>
                    </>
                    )}
                </Td>
                </Tr>
            ))}

            </Tbody>

        </Table>
      </Box>

    </Box>
  );
};

export default B2CQsetCategoryManager;
